import "./StartProject.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LetSCreate from "./sections/LetSCreate";
import OurBase from "./sections/OurBase";
import StudioFooter from "@/reusable_sections/Footer";
export default function StartProjectPage() {
  return <div>
      <MainNavigation />
      <LetSCreate />
      <OurBase />
      <StudioFooter />
    </div>;
}